import { Button, ModalContent } from '@sandtech-hub-monorepo/ui-kit';
import { ReactComponent as BulbIcon } from '../../../assets/Icons/bulb.svg';
import React from 'react';
import { ReactComponent as SwanickerScholarsLogo } from '../../../assets/pathway-transition-logos/swanikerScholars.svg';
import { ReactComponent as NexfrordUniversityLogo } from '../../../assets/pathway-transition-logos/nexfordUniversity.svg';
import { ReactComponent as SaaLogo } from '../../../assets/pathway-transition-logos/saa.svg';
import { Link } from 'react-router-dom';

interface OpportunitiesModalProps {
  close: () => void;
}

export const OpportunitiesModal = ({ close }: OpportunitiesModalProps) => {
  const scholarshipLinks = [
    {
      logo: SwanickerScholarsLogo,
      url: 'https://forms.alxafrica.com/252612211626548',
    },
    {
      logo: NexfrordUniversityLogo,
      url: 'https://forms.alxafrica.com/252603286517559',
    },
    {
      logo: SaaLogo,
      url: 'https://forms.alxafrica.com/252602745893565',
    },
  ];

  const resourceLinks = [
    {
      title: 'Transitions\nBrochure',
      url: 'https://drive.google.com/file/d/1Y0AJ7MvYHWMXLOwxu_AvIQv1HZwE3RIN/view',
    },
    {
      title: 'Transitions\nWebinar',
      url: 'https://alxafrica.zoom.us/webinar/register/WN_MbxGRoesQR6aW6p8URZT4w#/registration',
    },
    {
      title: 'Transitions\nGuide',
      url: 'https://drive.google.com/file/d/1cRs8nx6D3uV5i_sKqdkpUXU4TReCv95D/view',
    },
    {
      title: 'Partner\nUniversities',
      url: 'https://drive.google.com/file/d/1GH_2z8IizB_0V2eyPRwff7LsPZmLiRO2/view',
    },
    {
      title: 'Open\nOpportunities',
      url: 'https://docs.google.com/presentation/d/1OUf74I4pjhLtJoUfMt_2k1-8f-SLDovnIuT1Zws2QnI/edit?slide=id.g3808e1fb426_0_37#slide=id.g3808e1fb426_0_37',
    },
    {
      title: 'Need\nSupport?',
      url: 'https://share.cody.bot/9f4f63a5-a779-498a-bac4-72482b8ad08f',
    },
  ];

  return (
    <ModalContent>
      {/* Modal content */}
      <div className="flex flex-col items-center text-center gap-6 mx-auto px-4 sm:px-8 pb-8">
        {/* Header section */}
        <div className="flex flex-col items-center gap-4">
          <div className="p-6 bg-primary/20 rounded-full text-primary mx-auto">
            <BulbIcon className="w-12 h-12" />
          </div>
          <div className="flex flex-col gap-4 items-center">
            <h2 className="text-primary font-semibold text-2xl">
              Opportunities Await
            </h2>
            <div className="text-foreground leading-normal max-w-lg px-2">
              ALX is excited to help you unlock opportunities after your
              program, from university and scholarships to career growth, for
              those who put in the work and stay the course.
              <br />
              <br />
              <span className="font-bold">
                Click below to apply for a sponsorship:
              </span>
            </div>
          </div>
        </div>

        {/* Scholarship cards */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full justify-center">
          {scholarshipLinks.map((scholarship, index) => (
            <div
              key={index}
              className="bg-background-tertiary border border-primary/20 rounded-lg p-4 sm:p-6 flex flex-col items-center justify-end gap-3 sm:gap-4 flex-1 sm:flex-initial sm:w-40 h-[130px] sm:h-[154px]"
            >
              <scholarship.logo />
              <Link
                to={scholarship.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button>Apply</Button>
              </Link>
            </div>
          ))}
        </div>

        {/* Resource links section */}
        <div className="flex flex-col gap-4 items-center w-full">
          <h3 className="text-foreground font-semibold text-base">
            Find more helpful links below:
          </h3>

          {/* Resource grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 w-full">
            {resourceLinks.map((link, index) => (
              <div
                key={index}
                className="bg-background border border-border rounded-lg p-4 sm:p-6 flex flex-col items-center justify-center gap-2 min-h-[80px] sm:min-h-[100px]"
              >
                <div className="text-foreground font-semibold text-center leading-5 whitespace-pre-line">
                  {link.title}
                </div>
                <Link to={link.url} target="_blank" rel="noopener noreferrer">
                  <Button variant="link" className="text-md">
                    Click here
                  </Button>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ModalContent>
  );
};
